import React from "react";

import { FormControl } from "kanopi-components/Input";
import {
  ButtonRadioInput as Input,
  ButtonRadioInputProps,
} from "kanopi-components/ButtonInput";

type TPaymentFrequencyInputProps = {
  label: string;
  showLabel: boolean;
  title: string;
  error?: string;
  help?: string;
} & ButtonRadioInputProps;

export const PaymentFrequencyInput: React.FC<TPaymentFrequencyInputProps> = (props) => {
  const {
    label,
    showLabel,
    title,
    onChange,
    value,
    options,
    error,
    help,
    name,
    ...restProps
  } = props;
  return (
    <FormControl
      label={label}
      title={title}
      caption={help}
      hideLabel={!showLabel}
      forceFocus
      error={error}
    >
      <Input
        onChange={onChange}
        value={value}
        options={
          options?.map(({ title, ...rest }) => ({ label: title, ...rest })) || []
        }
        textCenter={true}
        fullWidthForDescription={false}
        data-testid={name}
        {...restProps}
      />
    </FormControl>
  );
};
